import { ModelCommon } from './ModelCommon'
import { UserAttributeDefs } from '../types/ModelTypes'

const placeTypeName = 'PlaceStyler'

export interface IPlaceStyler {
  name: string | undefined
  id: string
  description: string | undefined
  color: string | undefined
  icon: string | undefined
}

class PlaceStyler extends ModelCommon implements IPlaceStyler {
  name: string | undefined
  id: string
  description: string | undefined
  color: string | undefined
  icon: string | undefined
  // primaryS3Image: any;

  constructor(ob: any) {
    super(placeTypeName, ob)
    this.name = ob.name
    this.id = ob.id
    this.description = ob.description
    this.color = ob.color
    this.icon = ob.icon
    // this.primaryS3Image = ob.primaryS3Image;
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      color: { type: 'String', editable: true, label: 'color', name: 'color', description: 'description' },
      // icon: { type: 'String', editable: true, label: 'icon', name: 'icon', description: 'description' },
    }
  }
}

export { PlaceStyler }
